<template>
  <div>
    <router-view />
  </div>
</template>
<script setup>
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
</style>
